import React from 'react';
import { DialogContent, DialogTitle } from '../shared/Dialog';
import { Ticket } from '@/lib/OrderApi';
import AmendTicketAnswers from './ticket-amend/AmendTicketAnswers';

interface AmendTicketAnswersModalProps {
  orderId: string;
  ticket: Ticket;
  onSuccess: () => void;
}

const AmendTicketAnswersModal: React.FC<AmendTicketAnswersModalProps> = ({ orderId, ticket, onSuccess }) => {
  return (
    <DialogContent className='bg-[var(--shop-panelBackgroundColor)] text-[var(--shop-textColor)]'>
      <DialogTitle className='text-center mx-auto'>
        {ticket.productName}{' '}
        <span className='text-xs tracking-tight'>
          {ticket.numberOfProductType}/{ticket.totalOfProductType}
        </span>
      </DialogTitle>
      <AmendTicketAnswers orderId={orderId} ticket={ticket} onSuccess={onSuccess} />
    </DialogContent>
  );
};

export default AmendTicketAnswersModal;
